import React from "react";
const Input = ({handleChange, value, placeholder}) => {
    return (
        <div style={{marginBottom: '15px'}}>
            <input
                type="text"
                value={value}
                onChange={handleChange}
                placeholder={placeholder}
                style={{
                    transition: 'all 100ms',
                    backgroundColor: 'hsl(0, 0%, 100%)',
                    borderColor: 'hsl(0, 0%, 80%)',
                    borderRadius: '4px',
                    borderStyle: 'solid',
                    borderWidth: '1px',
                    boxSizing: 'border-box',
                    padding: '10px 10px',
                    width: '750px'
                }}
            />
        </div>
    )
}

export default Input